import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useCircleDiagramData = (companyId, selectedYear) => {
    const [data, setData] = useState({ finishedTasks: 0, totalTasks: 0 });

    useEffect(() => {
        const fetchTasks = async () => {
            const yearDocPath = `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`;
            const yearDocRef = doc(db, yearDocPath);
            const docSnapshot = await getDoc(yearDocRef);

            if (docSnapshot.exists()) {
                const quartersData = docSnapshot.data();
                let finishedTasks = 0;
                let totalTasks = 0;

                
                ['Q1', 'Q2', 'Q3', 'Q4'].forEach(quarter => {
                    const tasks = quartersData[quarter] || [];
                    totalTasks += tasks.length;
                    finishedTasks += tasks.filter(task => task.isFinished).length;
                });

                setData({ finishedTasks, totalTasks });
            }
        };

        if (companyId && selectedYear) {
            fetchTasks();
        }
    }, [companyId, selectedYear]);

    return data;
};

export default useCircleDiagramData;
